export const aciLogin = {
    iconName: 'login',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M16.8 5.597a4.798 4.798 0 01-4.8 4.796A4.798 4.798 0 1112 .8c2.651 0 4.8 2.147 4.8 4.797zM20 23.185H4V19.99a4.8 4.8 0 014.8-4.8h6.4a4.8 4.8 0 014.8 4.8v3.195z',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
            },
        },
    },
};
